<template>
  <div>
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>
      <vs-row>

        <vs-col class="w-4/12 mb-4 flex">
          <vs-col class="h-full flex" style="width: 100px;" vs-align="center">현장명</vs-col>
          <vs-col class="w-8/12 flex" vs-align="center">
            <span v-if="isPrint">{{ form.inputA_1 }}</span>
            <ml-input v-else class="w-full" v-model="form.inputA_1" :readonly="true"/>
          </vs-col>
        </vs-col>

        <vs-col class="w-4/12 mb-4 pl-8 flex">
          <vs-col class="h-full flex" style="width: 100px;" vs-align="center">사업금액</vs-col>
          <vs-col class="w-8/12">
            <span v-if="isPrint">{{ form.inputA_2 }}</span>
            <comma-input v-else class="w-full" v-model="form.inputA_2" :readonly="board.readonly"/>
          </vs-col>
        </vs-col>

        <vs-col class="w-4/12 mb-4 pl-8 flex">
          <vs-col class="h-full flex" style="width: 100px;" vs-align="center">대상기간</vs-col>
          <vs-col class="w-8/12">
            <span v-if="isPrint">{{ form.inputA_3 }}</span>
            <ml-input v-else class="w-full" v-model="form.inputA_3" :readonly="board.readonly"/>
          </vs-col>
        </vs-col>

        <vs-col class="w-4/12 mb-4 flex">
          <vs-col class="h-full flex" style="width: 100px;" vs-align="center">안전보건부서장</vs-col>
          <vs-col class="w-8/12">
            <span v-if="isPrint">{{ form.inputA_4 }}</span>
            <ml-input v-else class="w-full" v-model="form.inputA_4" :readonly="board.readonly"/>
          </vs-col>
        </vs-col>

        <vs-col class="w-4/12 mb-4 pl-8 flex">
          <vs-col class="h-full flex" style="width: 100px;" vs-align="center">안전보건담당자</vs-col>
          <vs-col class="w-8/12">
            <span v-if="isPrint">{{ form.inputA_5 }}</span>
            <ml-input v-else class="w-full" v-model="form.inputA_5" :readonly="board.readonly"/>
          </vs-col>
        </vs-col>

        <vs-col class="w-full mb-4 flex">
          <vs-col class="h-full flex" style="width: 100px; min-width: 100px;" vs-align="center">주요내용</vs-col>
          <vs-col class="w-full">
            <span v-if="isPrint">{{ form.inputA_6 }}</span>
            <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputA_6" :readonly="board.readonly"/>
          </vs-col>
        </vs-col>

      </vs-row>
    </div>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>산업안전보건관리비</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8"
              style="border:1px solid #cdcdcd; ">
        <vs-col>
          <ul class="table table-5" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>항목별</span>
              <span>예산</span>
              <span>당월사용금액</span>
              <span>누계사용금액</span>
              <span>집행률</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="item in form.inputB" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value1 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value1" :readonly="board.readonly" @keyup="calculateB"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value2 }}</span>
                <ml-input v-else class="w-full" v-model="item.value2" :readonly="board.readonly" @keyup="calculateB"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value3 }}</span>
                <ml-input v-else class="w-full" v-model="item.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value4 }}</span>
                <ml-input v-else class="w-full" v-model="item.value4" :readonly="true"/>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">누계</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value1 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value1" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value2 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value2" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value3 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value4 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value4" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

    <!-- 안전관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>안전관리비</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8"
              style="border:1px solid #cdcdcd; ">
        <vs-col>
          <ul class="table table-5" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>항목별</span>
              <span>예산</span>
              <span>당월사용금액</span>
              <span>누계사용금액</span>
              <span>집행률</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="item in form.inputC" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value1 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value1" :readonly="board.readonly" @keyup="calculateC"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value2 }}</span>
                <ml-input v-else class="w-full" v-model="item.value2" :readonly="board.readonly" @keyup="calculateC"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value3 }}</span>
                <ml-input v-else class="w-full" v-model="item.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value4 }}</span>
                <ml-input v-else class="w-full" v-model="item.value4" :readonly="true"/>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">누계</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputC.value1 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputC.value1" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputC.value2 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputC.value2" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputC.value3 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputC.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputC.value4 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputC.value4" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

    <file-upload-module v-model="form.fileList">

    </file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  name: 'Write.vue',
  components: {FileUploadModule},
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  computed: {
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    totalInputB () {
      const totalInputB = {label: '누계', value1: 0, value2: 0, value3: 0, value4: 0}

      for (const inputB of this.form.inputB) {
        totalInputB.value1 += Number(this.removeComma(inputB.value1) ? this.removeComma(inputB.value1) : 0)
        totalInputB.value2 += Number(this.removeComma(inputB.value2) ? this.removeComma(inputB.value2) : 0)
        totalInputB.value3 += Number(this.removeComma(inputB.value3) ? this.removeComma(inputB.value3) : 0)
      }
      totalInputB.value4 = Math.floor(totalInputB.value2 * 10000.0 / totalInputB.value1) / 100

      totalInputB.value1 = this.comma(totalInputB.value1)
      totalInputB.value2 = this.comma(totalInputB.value2)
      totalInputB.value3 = this.comma(totalInputB.value3)
      return totalInputB
    },
    totalInputC () {
      const totalInputC = {label: '누계', value1: 0, value2: 0, value3: 0, value4: 0}

      for (const inputC of this.form.inputC) {
        totalInputC.value1 += Number(this.removeComma(inputC.value1) ? this.removeComma(inputC.value1) : 0)
        totalInputC.value2 += Number(this.removeComma(inputC.value2) ? this.removeComma(inputC.value2) : 0)
        totalInputC.value3 += Number(this.removeComma(inputC.value3) ? this.removeComma(inputC.value3) : 0)
      }
      totalInputC.value4 = Math.floor(totalInputC.value2 * 10000.0 / totalInputC.value1) / 100

      totalInputC.value1 = this.comma(totalInputC.value1)
      totalInputC.value2 = this.comma(totalInputC.value2)
      totalInputC.value3 = this.comma(totalInputC.value3)
      return totalInputC
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
      }
    },
    async value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }

      const postId = this.$route.params.postId
      if (!postId) {
        await this.loadListApproval()
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form))
      for (let i = 0; i < this.oldForm.inputB.length; i++) {
        this.oldForm.inputB[i].value3 = Number(this.removeComma(`${this.oldForm.inputB[i].value3}`)) - Number(this.removeComma(`${this.oldForm.inputB[i].value2}`))
      }
      for (let i = 0; i < this.oldForm.inputC.length; i++) {
        this.oldForm.inputC[i].value3 = Number(this.removeComma(`${this.oldForm.inputC[i].value3}`)) - Number(this.removeComma(`${this.oldForm.inputC[i].value2}`))
      }
      this.calculateB()
      this.calculateC()
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        value.summary = {
          안전보건관리비: [],
          안전관리비: [],
        }

        for (const data of this.form.inputB) {
          value.summary['안전보건관리비'].push({
            [data.label]: Number(this.removeComma(`${data.value2}`))
          })
        }

        for (const data of this.form.inputC) {
          value.summary['안전관리비'].push({
            [data.label]: Number(this.removeComma(`${data.value2}`))
          })
        }
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      totalB: [],
      totalC: [],
      oldForm: {},
      form: {
        fileList: [],
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputB: [
          {label: '안전관리자 등 인건비 및 각종업무수당 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전시설비 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '개인보호구 및 안전장구 구입비 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전진단비 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건교육비 및 행사비 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '근로자 건강관리비 등', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '건설재해예방 기술지도비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '본사 사용비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '기타(산업안전보건관리비)', value1: 0, value2: 0, value3: 0, value4: 0.0},
        ],
        inputC: [
          {label: '안전관리계획서 작성비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '현장안전점검비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '공사장 주변 안전관리 사용비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '통행안전 및 교통소통 대책비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '공사 중 구조적 안전성 확보비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '기타(안전관리비)', value1: 0, value2: 0, value3: 0, value4: 0.0},
        ],
      }
    }
  },
  async mounted () {
    this.calculateB()
    this.calculateC()
  },
  methods: {
    async loadListApproval () {
      const projectId = this.$route.params.proj_id
      const boardSlug = 'safety-and-health-budget-status'
      const page = 1
      const perPage = 10000
      const dateTarget = ['created_at']
      const dateBegin = [`${new Date().getFullYear()}-01-01`]
      const dateEnd = [`${new Date().getFullYear()}-12-31`]

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd
      })
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.approval.list))]

      const totalB = []
      const totalC = []
      for (const data of rows) {
        if (data.post.author.company_id === this.myInfo.company_id) {
          // const month = Number(`${this.getHeader(data).month}`)
          const content = this.getContent(data)

          for (let i = 0; i < content.inputB.length; i++) {
            const inputB = content.inputB[i]
            if (!totalB[i]) {
              totalB[i] = {
                value2: Number(inputB.value2)
              }
            } else {
              totalB[i] = {
                value2: totalB[i].value2 + Number(inputB.value2)
              }
            }
          }

          for (let i = 0; i < content.inputC.length; i++) {
            const inputC = content.inputC[i]
            if (!totalC[i]) {
              totalC[i] = {
                value2: Number(inputC.value2)
              }
            } else {
              totalC[i] = {
                value2: totalC[i].value2 + Number(inputC.value2)
              }
            }
          }
        }
      }

      this.totalB = totalB
      this.totalC = totalC
    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },

    calculateB () {
      const list = []
      for (let i = 0; i < this.form.inputB.length; i++) {
        const inputB = this.form.inputB[i]
        const value = {
          label: inputB.label,
          value1: this.removeComma(inputB.value1),
          value2: this.removeComma(inputB.value2),
        }
        if (this.totalB && this.totalB[i]) {
          value.value3 = Number(this.removeComma(this.totalB[i].value2)) + Number(`${value.value2}`)
        } else {
          value.value3 = Number(this.removeComma(`${this.oldForm.inputB[i].value3}`)) + Number(`${value.value2}`)
        }
        value.value4 = Math.floor(Number(this.removeComma(`${value.value2}`)) * 10000.0 / Number(this.removeComma(`${value.value1}`))) / 100
        list.push(value)
      }

      for (const inputB of list) {
        inputB.value1 = this.comma(inputB.value1)
        inputB.value2 = this.comma(inputB.value2)
        inputB.value3 = this.comma(inputB.value3)
        inputB.value4 = inputB.value4 ? inputB.value4 : '0'
      }
      this.form.inputB = JSON.parse(JSON.stringify(list))
    },
    calculateC () {
      const list = []
      for (let i = 0; i < this.form.inputC.length; i++) {
        const inputC = this.form.inputC[i]
        const value = {
          label: inputC.label,
          value1: this.removeComma(inputC.value1),
          value2: this.removeComma(inputC.value2),
        }
        if (this.totalC && this.totalC[i]) {
          value.value3 = Number(this.removeComma(this.totalC[i].value2)) + Number(`${value.value2}`)
        } else {
          value.value3 = Number(this.removeComma(`${this.oldForm.inputC[i].value3}`)) + Number(`${value.value2}`)
        }
        value.value4 = Math.floor(Number(this.removeComma(`${value.value2}`)) * 10000.0 / Number(this.removeComma(`${value.value1}`))) / 100
        list.push(value)
      }

      for (const inputB of list) {
        inputB.value1 = this.comma(inputB.value1)
        inputB.value2 = this.comma(inputB.value2)
        inputB.value3 = this.comma(inputB.value3)
        inputB.value4 = inputB.value4 ? inputB.value4 : '0'
      }
      this.form.inputC = JSON.parse(JSON.stringify(list))
    },
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma (str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    }
  }
}
</script>

<style scoped>

</style>
